export class ProductForm extends window.PURELEI.CustomElement() {
    setupListeners() {
        super.setupListeners()

        this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))
        if (this.els.addToCartButton) {
            this.listeners.add(this.els.addToCartButton.element, 'click', (e) => {
                this.els.addToCartButton.element.classList.add('clicked')
            })
        }
    }

    checkValidity() {
        super.checkValidity()

        if (!this.form) {
            this.throwError(`needs to be wrapped around a product's <form> element`)
        }
    }

    async onSubmitHandler(e) {
        e.preventDefault()
        e.stopPropagation()

        if(window.ctx) return;

        await this.addToCart(e)
    }

    async addToCart(e) {
        if(window.ctx) return;
        window.ctx = true

        let result;

        if (e.submitter.className.includes('pdp')) {
            result = await window.PURELEI.Cart.addItemFromFormWithoutEngraving(this.form)
        } else {
            result = await window.PURELEI.Cart.addItemFromForm(this.form)
        }

        window.ctx = false;

        return result;
    }

    /**
     * @returns {HTMLFormElement|null}
     */
    get form() {
        return this.closest('form.prd-DetailForm_Form');
    }
}

customElements.define('product-form', ProductForm)
